
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ChevronLeft, ArrowLeft, ArrowRight } from 'lucide-react';

interface ExhibitNavigationProps {
  prevExhibit: { id: string } | null;
  nextExhibit: { id: string } | null;
  dir: string;
  t: (key: string) => string;
  tourId?: string | null;
}

const ExhibitNavigation = ({ prevExhibit, nextExhibit, dir, t, tourId }: ExhibitNavigationProps) => {
  // In RTL, the "next" should point left (backward in RTL display), "prev" should point right (forward in RTL display)
  // In LTR, the "next" should point right (forward in LTR display), "prev" should point left (backward in LTR display)
  const NextIcon = dir === 'rtl' ? ArrowLeft : ArrowRight;
  const PrevIcon = dir === 'rtl' ? ArrowRight : ArrowLeft;
  
  // Only show navigation if we have either previous or next exhibit
  if (!prevExhibit && !nextExhibit) {
    return null;
  }

  // Create state object to maintain tour context
  const createNavigationState = () => ({
    from: tourId ? `tour-${tourId}` : undefined
  });
  
  return (
    <div className="flex justify-between mt-8 pt-6 border-t border-border">
      {prevExhibit ? (
        <Link 
          to={`/exhibit/${prevExhibit.id}`}
          state={createNavigationState()}
          className="flex items-center gap-2 text-primary hover:underline transition-colors"
        >
          <PrevIcon className="h-5 w-5" />
          <span>{t('previous')}</span>
        </Link>
      ) : <div></div>}
      
      {nextExhibit ? (
        <Link 
          to={`/exhibit/${nextExhibit.id}`}
          state={createNavigationState()}
          className="flex items-center gap-2 text-primary hover:underline transition-colors"
        >
          <span>{t('next')}</span>
          <NextIcon className="h-5 w-5" />
        </Link>
      ) : <div></div>}
    </div>
  );
};

export default ExhibitNavigation;
